import { FunctionComponent } from 'react'
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import { Controller, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { BootstrapDialog } from 'components/BootstrapDialog'
import { RequiredStar } from 'components/RequiredStarSpan'
import { DialogCloseButton } from 'components/DialogCloseButton'
import { ProcurementRequirementItem } from 'types/lots'
import { EBidProcurementMeasurement } from 'types/bids/bidProcurementItems'
import { IProcurement } from 'types/procurements'

const capitalize: Function = (text: string) => {
  return text.charAt(0).toLocaleUpperCase('az') + text.slice(1).toLocaleLowerCase()
}

interface FormData {
  orgName: string
  reason: string
}

interface Props {
  handleClose: () => void
  onAdd: (values: FormData) => void
}

export const AddRejectedSubmitterOrganizationForm: FunctionComponent<Props> = ({
  handleClose,
  onAdd,
}) => {
  const { t } = useTranslation()
  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
  } = useForm<FormData>({
    reValidateMode: 'onSubmit',
    defaultValues: {
      orgName: '',
      reason: '',
    },
  })

  const onSubmit = (data: FormData) => {
    onAdd(data)
    handleClose()
  }

  return (
    <BootstrapDialog open onClose={handleClose}>
      <DialogTitle sx={{ m: 0, p: 2 }}>
        {t('technical-evaluation-results-item')}
      </DialogTitle>

      <DialogCloseButton handleClose={handleClose} />

      <DialogContent dividers>
        <FormControl sx={{ minWidth: 120 }} fullWidth margin="normal">
          <TextField
            label={<>{t('supplier-name')}</>}
            variant="outlined"
            {...register('orgName')}
          />
        </FormControl>

        <FormControl sx={{ minWidth: 120 }} fullWidth margin="normal">
          <TextField
            label={<>{t('reason')}</>}
            variant="outlined"
            {...register('reason')}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          onClick={handleSubmit(onSubmit)}
          variant="contained"
          style={{ color: '#fff', backgroundColor: 'rgb(3, 34, 76)' }}
        >
          {t('add')}
        </Button>
      </DialogActions>
    </BootstrapDialog>
  )
}
